module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/simple-assign/index.js
 ** module id = 9
 ** module chunks = 0
 **/